import {all} from 'redux-saga/effects';
// import authSagas from './Auth';
import inspectionSagas from "./Inspections";
import inventorySagas from "./Inventory";
import merchandisingSagas from "./Merchandising";
import reportSagas from "./Reports";
import scannerSagas from "./Scanner";

export default function* rootSaga(getState) {
  yield all([
      // authSagas()
      inspectionSagas(),
      inventorySagas(),
      merchandisingSagas(),
      reportSagas(),
      scannerSagas(),
  ]);
}
